<template>
  <div class="mfPassword" v-show="isOpen">
    <div class="mfForm">
      <p>修改密码</p>
      <div class="Password public">
        <input
          type="password"
          placeholder="请输入您当前的密码"
          v-validate
          v-model="password"
          :data-vv-rules="rules"
          :class="{ input: true, 'is-danger': errors.has('密码') }"
          name="密码"
        />
      </div>
      <span v-show="errors.has('密码')" class="help is-danger">{{ errors.first('密码') }}</span>
      <div class="newPassword public">
        <input
          type="text"
          placeholder="请输入您的新密码"
          v-validate
          v-model="newpassword"
          data-vv-rules="password"
          :class="{ input: true, 'is-danger': errors.has('新密码') }"
          name="新密码"
        />
      </div>
      <span v-show="errors.has('新密码')" class="help is-danger">{{ errors.first('新密码') }}</span>
      <div class="reLogin" @click="Confirm">确认并重新登录</div>
    </div>
    <div class="toClose" @click="closed"><img src="../assets/images/toClosed.png" /></div>
  </div>
</template>

<script>
import storage from '../utils/storage'
import { Dialog } from 'vant'
import PartnerApi from '../api/partner'

export default {
  name: 'modify-password',
  data() {
    return {
      isOpen: false,
      password: '',
      newpassword: '',
      rules: 'oldPasswd:' + window.localStorage.oldPasswd
    }
  },
  methods: {
    closed() {
      this.isOpen = false
    },
    Confirm() {
      this.$validator.validateAll()
      if (this.errors.any()) {
        return
      }
      let userID = storage.getLocalStorage('user').uid
      let pwd = {
        pwdNew: this.newpassword,
        pwdOld: this.password,
        uid: userID
      }
      PartnerApi.changePassword(pwd).then(
        response => {
          let returnData = response.data
          if (returnData.success) {
            Dialog.alert({
              title: '提示',
              message: '修改成功，请重新登录',
              confirmButtonText: 'confirm'
            }).then(() => {
              // on close
              window.localStorage.clear()
              this.$router.replace('/login')
            })
          } else {
            Dialog.alert({
              title: '提示',
              message: returnData.msg
            }).then(() => {})
          }
        },
        response => {
          console.log('error')
        }
      )
    }
  }
}
</script>

<style scoped>
@media (max-width: 750px) {
  .mfPassword {
    height: 100%;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  .toClose {
    width: 1.408rem;
    height: 1.408rem;
    position: absolute;
    right: 2.24rem;
    top: 3.8187rem;
  }

  .mfPassword img {
    width: 100%;
    height: 100%;
  }

  .mfForm {
    width: 11.52rem;
    height: 12.52rem;
    box-sizing: border-box;
    border-radius: 0.512rem;
    background: white;
    position: absolute;
    left: 2.24rem;
    top: 5.6533rem;
  }

  .mfForm > p {
    height: 0.6827rem;
    line-height: 1;
    font-size: 0.6827rem;
    color: #00a0e9;
    margin-top: 0.9387rem;
    margin-bottom: 1.5rem;
    text-align: center;
  }

  .public {
    width: 9.152rem;
    height: 1.7rem;
    border: solid 2px #c7c7c7;
    border-radius: 0.9387rem;
    padding-left: 0.5rem;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 1.5rem;
  }

  .help {
    display: block;
    font-size: 0.5rem;
    text-align: left;
    margin-left: 2rem;
    position: absolute;
  }

  .Password input,
  .newPassword input {
    width: 6rem;
    height: 0.9387rem;
    background: transparent;
    border: 0;
    font-size: 0.56rem;
    line-height: 1;
    display: block;
    float: left;
    margin-top: 0.33rem;
    margin-left: 0.2rem;
    color: #ccc;
    font-family: inherit;
  }

  .reLogin {
    width: 9.152rem;
    height: 1.8773rem;
    margin: 0 auto;
    border-radius: 0.9387rem;
    background: rgba(0, 159, 233, 0.8);
    margin-top: 1.324rem;
    color: white;
    line-height: 1.8773rem;
    font-size: 0.768rem;
    text-align: center;
  }
}
@media (min-width: 750px) {
  .mfPassword {
    height: 100%;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  .toClose {
    width: 66px;
    height: 66px;
    position: absolute;
    right: 50%;
    margin-right: -267px;
    top: 10px;
    font-size: 24px;
  }

  .mfPassword img {
    width: 100%;
    height: 100%;
  }

  .mfForm {
    width: 540px;
    height: 540px;
    box-sizing: border-box;
    border-radius: 24px;
    background: white;
    position: absolute;
    left: 50%;
    top: 90px;
    margin-left: -270px;
  }

  .mfForm > p {
    height: 32px;
    line-height: 1;
    font-size: 32px;
    color: #00a0e9;
    margin-top: 44px;
    margin-bottom: 70px;
    text-align: center;
  }

  .public {
    width: 429px;
    height: 80px;
    border: solid 2px #c7c7c7;
    border-radius: 40px;
    padding-left: 56px;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 25px;
  }

  .help {
    display: block;
    font-size: 0.5rem;
    text-align: left;
    margin-left: 2rem;
    position: absolute;
  }

  .Password input,
  .newPassword input {
    width: 429px;
    height: 80px;
    background: transparent;
    border: 0;
    font-size: 28px;
    line-height: 1;
    display: block;
    float: left;
    color: #ccc;
    font-family: inherit;
  }

  .reLogin {
    width: 429px;
    height: 80px;
    margin: 0 auto;
    border-radius: 40px;
    background: rgba(0, 159, 233, 0.8);
    margin-top: 48px;
    color: white;
    line-height: 80px;
    font-size: 36px;
    text-align: center;
  }
}
</style>
